// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__3sSuD","errorLogs":"styles_errorLogs__N0TQG"};